import { createListLoadingReducer } from './utils';
import { AccessKeyType } from '@/types';

export default createListLoadingReducer<AccessKeyType>('ACCESSKEYTYPES');
